// extracted by mini-css-extract-plugin
export var card = "article-card-module--card--mlL2M";
export var cardContainer = "article-card-module--card-container--d4un5";
export var image = "article-card-module--image--jDWsk";
export var imageWrapper = "article-card-module--image-wrapper--EdrKx";
export var swiperTitle = "article-card-module--swiper-title--n1xYP";